// extracted by mini-css-extract-plugin
export default {"App":"Layout_App__Fw9VO","AppOpen":"Layout_AppOpen__wonH8","Main":"Layout_Main__-1TMo","Footer":"Layout_Footer__oUCJt"};